import * as React from "react";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

interface Props {
    date: Date;
    setDate: React.Dispatch<React.SetStateAction<Date>>;
    children: React.ReactNode;
}

export function FancyDatePicker({ date, setDate, children }: Props) {
    return (
        <Popover defaultOpen>
            <PopoverTrigger>{children}</PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                {/* @ts-ignore */}
                <Calendar defaultMonth={date} ISOWeek mode="single" selected={date} onSelect={setDate} initialFocus />
            </PopoverContent>
        </Popover>
    );
}
